module.exports = __webpack_public_path__ + "img/02-4成本节约.f570c519.svg";